<template>
  <div
    class="modal fade"
    id="AgentLoginModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div
      class="modal-dialog"
      role="document"
    >
      <div class="modal-content">
        <div class="modal-header">
          <h5
            class="modal-title"
            id="exampleModalLabel"
												data-test="agentLoginModalHeading"
          >Login</h5>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
												data-test="agentLoginModalCloseButton"
												id="agentLoginModalCloseButton"
          >
            <span aria-hidden="true" data-test="agentLoginModalCloseSpan"
																		id="agentLoginModalCloseSpan">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <form
            data-vv-scope="login"
            @submit.prevent="action('login')"
          >
            <div class="form-group ">
              <label
                class="control-label requiredField"
                for="select"
																data-test="agentLoginModalPasswordLabel"
																id="agentLoginModalPasswordLabel"
              >
                Password
                <!--OTp not implemented-->
                <span class="asteriskField"
																						data-test="agentLoginModalPasswordSpan"
																						id="agentLoginModalPasswordSpan">
                  *
                </span>
              </label>
              <select
                class="select form-control"
                id="select"
                name="select"
                v-validate="'required|included:Password,OTP'"
                :class="(showLoginError &&
                          errors.has('login.select'))?'is-invalid':''"
                @change="optionSelect"
																data-test="agentLoginModalSelect"
              >
                <option data-test="agentLoginModalSelectOption"
																								id="agentLoginModalSelectOption">
                  Select...
                </option>
                <option value="Password" data-test="agentLoginModalPasswordOption"
																								id="agentLoginModalPasswordOption">
                  Password
                </option>
                <!--<option value="OTP">-->
                <!--OTP-->
                <!--</option>-->
              </select>
              <div
                class="invalid-feedback"
                v-if="showLoginError"
                v-show="errors.has('login.select')"
                id="vendor-RegisterForm-hostCountryName-error"
																data-test="agentLoginModalSelectError"
              >
                {{errors.first('login.select')}}
              </div>
            </div>

            <div
              class="form-group"
              v-if="show"
            >
              <label
                class="control-label "
                for="text"
																data-test="agentLoginModalEventLabel"
																id="agentLoginModalEventLabel"
              >
                {{eventValue}}
              </label>
              <input
                class="form-control"
                id="text"
                name="text"
                type="password"
                v-model="emailAcct.password"
                v-validate="'required'"
                autocomplete="off"
                :class="(showLoginError &&
                          errors.has('login.text'))?'is-invalid':''"
																data-test="agentLoginModalTextInput"
              />
              <div
                class="invalid-feedback"
                v-if="showLoginError"
                v-show="errors.has('login.text')"
                id="vendor-RegisterForm-otp-error"
																data-test="agentLoginModalTextError"
              >
                {{errors.first('login.text')}}
              </div>
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-primary btn-type-primary"
                @click.prevent="action('login')"
																data-test="agentLoginModalLoginButton"
																id="agentLoginModalLoginButton"
              >
                Login
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
	name: 'vendor-login-modal',
	data () {
		return {
			emailAcct: {
				email: ''
			},
			show: false,
			eventValue: '',
			showLoginError: false,
			otpLogin: {
				otp: ''
			}
		}
	},
	props: {
		email: null
	},
	methods: {
		action (scope) {
			this.$validator.validateAll(scope)
				.then((result) => {
					if (result) {
						this.showLoginError = false
						//
						// this.vendorLoginOtp(this.otpLogin);
						this.$emit('agentLoginViaPassword', this.emailAcct)
					} else {
						this.showLoginError = true
					}
				})
		},
		optionSelect (event) {
			this.show = true
			this.eventValue = event.target.value
			if (event.target.value === 'OTP') {
				this.emailAcct.email = this.email
				this.vendorOtpRequest(this.emailAcct)
			} else {
				this.emailAcct.username = this.email
			}
		}
	}
}
</script>
